// ============================================================
// ANSICHTSSACHE-AGENT – Leerer Zustand
// ============================================================
// Ein leerer Bereich ist die erste Seite, die ein neuer Nutzer
// von einem Bereich sieht. Sie sollte deshalb nicht wie ein
// Fehler aussehen, sondern wie ein Anfang: gefasste Flaeche,
// Symbol, ein Satz Erklaerung, ein Knopf.
// ============================================================

import type { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

interface EmptyStateProps {
  title: string;
  description?: string;
  /** Optional — ohne Symbol bleibt der Zustand eine reine Textzeile. */
  icon?: LucideIcon;
  action?: React.ReactNode;
  className?: string;
}

function EmptyState({ title, description, icon: Icon, action, className }: EmptyStateProps) {
  return (
    <div
      className={cn(
        // Gestrichelt gefasst: die Flaeche ist da, aber noch nicht
        // gefuellt. Eine durchgezogene Linie wuerde behaupten, hier
        // sei etwas fertig.
        "border-border flex flex-col items-center justify-center rounded-xl border border-dashed px-6 py-12 text-center",
        className,
      )}
    >
      {Icon && (
        <span className="bg-bg-tertiary text-text-tertiary mb-4 grid h-11 w-11 place-items-center rounded-xl">
          <Icon className="h-5 w-5" aria-hidden />
        </span>
      )}
      <p className="text-heading-sm text-text-primary">{title}</p>
      {description && (
        <p className="text-body-sm text-text-secondary mt-1.5 max-w-sm">{description}</p>
      )}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}

export { EmptyState };
